<template>
  <div class="item">
    <AppInfoItem
      v-for="(item, index) in items"
      :key="items[index].app"
      :itemKey="items[index].app"
      :itemValue="convertToK(items[index].value)"
      :capability="items[index].capability"
      :animationDelay="`${index}s`"
      :serviceName="items[index].serviceName"
      :serviceId="items[index].serviceId"
    />
  </div>
</template>
<script>
import AppInfoItem from './app-info-item.vue';
import { convertToK } from '@/utils/helper-function';

export default {
  components: { AppInfoItem },
  data() {
    return {
      type: 'ByCap',
    };
  },
  methods: {
    async getData() {},
    convertToK,
  },
  computed: {
    items() {
      const mappedItems = this.apps.map((app) => ({
        ...app,
        capability: app.capability,
        serviceName: app.serviceName,
      }));
      return mappedItems;
    },
  },
  props: {
    apps: { type: Array, default: () => [] },
  },
};
</script>
<style scoped>
.item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
